module.exports = __webpack_public_path__ + "static/media/snipe.4b874f43.svg";